import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function HeaderSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div
      {...useBlockProps.save()}
      className="header-2-col alignfull w-100 d-flex flex-column flex-xl-row"
    >
      <InnerBlocks.Content />
    </div>
  );
}
